// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FilesPage_wrapper__ta7Fs","heading":"FilesPage_heading__LOtvm"};